import { render, staticRenderFns } from "./RevokeModalSuccess.vue?vue&type=template&id=1f36844a"
import script from "./RevokeModalSuccess.vue?vue&type=script&lang=js"
export * from "./RevokeModalSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports